module.exports = __webpack_public_path__ + "static/assets/yolomed_logo_light.png";